export default __webpack_public_path__ + "static/media/healthq2.3a2db098.svg";